import React from "react";
import { Box, Skeleton } from "@mui/material";

const COLUMN_COUNT = 5;

const SkeletonTableRow = ({ height = 20, sx }) => (
  <Box
    sx={{
      display: "flex",
      width: "100%",
      alignItems: "center",
      justifyContent: "space-between",
      gap: 1,
      ...sx,
    }}
  >
    {Array.from({ length: COLUMN_COUNT }).map((_, index) => (
      <Box key={index} sx={{ flex: 1, minWidth: 0 }}>
        <Skeleton variant="text" width="100%" height={height} />
      </Box>
    ))}
  </Box>
);

const SkeletonSection = () => (
  <Box
    sx={{
      display: "flex",
      flexDirection: "column",
      flex: 1,
      minWidth: 0,
      minHeight: 0,
      overflow: "hidden",
      gap: 1,
    }}
  >
    <Skeleton variant="text" width={220} height={28} />
    <Skeleton variant="rectangular" width="100%" height={48} sx={{ borderRadius: 1 }} />
    <Box
      sx={{
        width: "100%",
        flex: 1,
        minHeight: 0,
        display: "flex",
        flexDirection: "column",
        overflow: "hidden",
        border: "1px solid",
        borderColor: "divider",
        borderRadius: "4px",
      }}
    >
      <Box
        sx={{
          px: 1.5,
          py: 1.5,
          borderBottom: "1px solid",
          borderColor: "divider",
          flexShrink: 0,
        }}
      >
        <SkeletonTableRow height={24} />
      </Box>
      <Box sx={{ flex: 1, minHeight: 0, overflowY: "auto", px: 1.5, py: 1.5 }}>
        {Array.from({ length: 8 }).map((_, index) => (
          <SkeletonTableRow key={index} height={20} sx={{ mb: 1 }} />
        ))}
      </Box>
    </Box>
  </Box>
);

const BlacklistedSecuritiesSkeleton = () => {
  return (
    <Box
      sx={{
        marginTop: 2,
        flex: 1,
        display: "flex",
        flexDirection: "column",
        minHeight: 0,
        overflow: "hidden",
        width: "100%",
      }}
    >
      <Box
        sx={{
          flex: 1,
          display: "flex",
          flexDirection: "column",
          minHeight: 0,
          overflow: "hidden",
          gap: 2,
        }}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            width: "100%",
            flexShrink: 0,
          }}
        >
          <Skeleton variant="rectangular" width={120} height={32} sx={{ borderRadius: 1 }} />
          <Skeleton variant="rectangular" width={150} height={40} sx={{ borderRadius: 1 }} />
        </Box>

        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            width: "100%",
            flex: 1,
            minHeight: 0,
            overflow: "hidden",
            gap: 2,
          }}
        >
          <SkeletonSection />
          <SkeletonSection />
        </Box>
      </Box>
    </Box>
  );
};

export default BlacklistedSecuritiesSkeleton;
